import * as React from "react";

function Menu(props) {
  return (
    <svg width={24} height={18} fill="none" {...props}>
      <path
        d="M3.2.035a2.285 2.285 0 100 4.57 2.285 2.285 0 000-4.57zm0 13.36a2.285 2.285 0 100 4.57 2.285 2.285 0 000-4.57zM7.773 3.072h14.561a.75.75 0 100-1.5H7.773a.75.75 0 000 1.5zM22.334 8.25h-8.561a.75.75 0 100 1.5h8.561a.75.75 0 100-1.5zm0 6.678H7.773a.75.75 0 100 1.5h14.561a.75.75 0 100-1.5z"
        fill="currentColor"
        stroke="none"
      />
    </svg>
  );
}

const MenuIcon = React.memo(Menu);
export default MenuIcon;
